import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const SmoothBlendIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-smoothBlend"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <polygon fill="#ffffff" className={styles.white} opacity="0" points="0 34 68 34 68 0 0 0" />
        <polygon
          fill="#0050B3"
          className={styles.interactiveColor}
          points="23 25 41 25 41 13 23 13"
        />
        <g transform="translate(22 1)">
          <path
            d="M12.999,10 C14.38415,10 15.1701115,10.2773887 16.3046013,11.0048262 L16.7701975,11.3098259 C17.5334565,11.8006355 17.9828625,11.9715655 18.7749782,11.9966454 L19,12 L19,14 C17.6142936,14 16.8280524,13.7225389 15.6933243,12.9949561 L15.2277353,12.6899611 C14.3953215,12.1546742 13.9364433,12 12.999,12 C12.0609863,12 11.601934,12.1547074 10.7690696,12.6901989 L10.5525722,12.8321356 C9.27800141,13.6815663 8.48165187,14 6.997,14 C5.61249638,14 4.82688168,13.7225478 3.69300665,12.9950224 L3.44435774,12.8321723 C2.54393001,12.2315869 2.08809973,12.0307047 1.22480548,12.0033535 L1,12 L1,10 C2.38505998,10 3.17095441,10.2775246 4.30506782,11.0051954 L4.55376726,11.1680778 C5.528981,11.8185455 5.98241057,12 6.997,12 C7.93501366,12 8.39406599,11.8452926 9.22693042,11.3098011 L9.44342779,11.1678644 C10.7179986,10.3184337 11.5143481,10 12.999,10 Z"
            fill="#0050B3"
            className={styles.interactiveColor}
            fillRule="nonzero"
          />
          <path
            d="M20.0416305,-0.999133073 C20.5540218,-0.977783438 20.9602556,-0.574481879 20.9972662,-0.0751695578 L20.9991331,0.0416305447 L19.959201,25 L0.0407989875,25 L-0.999133073,0.0416305447 C-1.02212499,-0.510175415 -0.593436504,-0.976141158 -0.0416305447,-0.999133073 C0.470760703,-1.02048271 0.909136663,-0.652373224 0.987556173,-0.157870489 L0.999133073,-0.0416305447 L1.959,23 L18.04,23 L19.0008669,-0.0416305447 C19.0222166,-0.554021793 19.4255181,-0.960255626 19.9248304,-0.997266175 L20.0416305,-0.999133073 Z"
            fill="#00000"
            className={styles.defaultColor}
            fillRule="nonzero"
          />
          <path
            d="M19.8827822,23 L0.117217781,23 L-1.13278222,33 L21.1327822,33 L19.8827822,23 Z M18.116,25 L18.866,31 L1.133,31 L1.883,25 L18.116,25 Z"
            fill="#00000"
            className={styles.defaultColor}
            fillRule="nonzero"
          />
          <path
            d="M11.5,28 C11.5,28.828 10.828,29.5 10,29.5 C9.172,29.5 8.5,28.828 8.5,28 C8.5,27.172 9.172,26.5 10,26.5 C10.828,26.5 11.5,27.172 11.5,28"
            fill="#ffffff"
            className={styles.white}
          />
          <path
            d="M10 26C8.89585763 26 8 26.8958576 8 28 8 29.1041424 8.89585763 30 10 30 11.1041424 30 12 29.1041424 12 28 12 26.8958576 11.1041424 26 10 26ZM10 27C10.5518576 27 11 27.4481424 11 28 11 28.5518576 10.5518576 29 10 29 9.44814237 29 9 28.5518576 9 28 9 27.4481424 9.44814237 27 10 27ZM23 5C23.5522847 5 24 5.44771525 24 6 24 6.51283584 23.6139598 6.93550716 23.1166211 6.99327227L23 7 20 7C19.4477153 7 19 6.55228475 19 6 19 5.48716416 19.3860402 5.06449284 19.8833789 5.00672773L20 5 23 5Z"
            fill="#00000"
            className={styles.defaultColor}
            fillRule="nonzero"
          />
          <path
            d="M24,3 C24.5128358,3 24.9355072,3.38604019 24.9932723,3.88337887 L25,4 L25,14 C25,14.5522847 24.5522847,15 24,15 C23.4871642,15 23.0644928,14.6139598 23.0067277,14.1166211 L23,14 L23,4 C23,3.44771525 23.4477153,3 24,3 Z"
            fill="#00000"
            className={styles.defaultColor}
            fillRule="nonzero"
          />
        </g>
      </g>
    </Icon>
  )
}
